/* ============================================================
   La Nuit — gallery-swipe.js
   Adds horizontal swipe navigation to the MAIN product gallery on
   touch devices. The gallery (assets/product-gallery.js) stacks its
   figures absolutely and shows one at a time via [aria-current]; there
   was no swipe, so on mobile shoppers could only tap thumbnails/dots.

   This drives the existing <product-gallery>._setActiveByMediaId(), so
   thumbnails, dots and the lightbox base image all stay in sync. The
   lightbox's own swipe lives in product-gallery.js and is unblocked by
   assets/gallery-fix.css (touch-action).

   Runs on window `load` so the <product-gallery> custom element is
   already defined/upgraded. No external deps.
   ============================================================ */

(function () {
  function visibleFigures(gallery) {
    return Array.prototype.slice
      .call(gallery.querySelectorAll('.product-gallery__figure'))
      .filter(function (fig) { return !fig.hidden; });
  }

  // Keep any existing dot strip (built by product-form.js) aligned with
  // the current figure after a swipe — best effort, by visible-order index.
  function syncDots(gallery) {
    var dots = gallery.querySelector('[data-gallery-dots]');
    if (!dots) return;
    var figs = visibleFigures(gallery);
    var cur = figs.findIndex(function (f) { return f.hasAttribute('aria-current'); });
    var buttons = dots.querySelectorAll('button');
    buttons.forEach(function (b, i) {
      b.setAttribute('aria-current', i === cur ? 'true' : 'false');
    });
  }

  function go(gallery, delta) {
    var figs = visibleFigures(gallery);
    if (figs.length < 2) return;
    var cur = figs.findIndex(function (f) { return f.hasAttribute('aria-current'); });
    if (cur < 0) cur = 0;
    var target = figs[(cur + delta + figs.length) % figs.length];
    if (target && typeof gallery._setActiveByMediaId === 'function') {
      gallery._setActiveByMediaId(target.dataset.mediaId);
      syncDots(gallery);
    }
  }

  function bind(gallery) {
    var stage = gallery.querySelector('[data-gallery-stage]');
    if (!stage || stage.dataset.swipeBound) return;
    stage.dataset.swipeBound = '1';
    // Capture horizontal pans for swipe; still allow vertical page scroll.
    stage.style.touchAction = 'pan-y';

    var startX = 0;
    var startY = 0;
    var tracking = false;
    var swiped = false;

    stage.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse') return; // touch / pen only
      tracking = true;
      startX = e.clientX;
      startY = e.clientY;
    });
    stage.addEventListener('pointerup', function (e) {
      if (!tracking) return;
      tracking = false;
      var dx = e.clientX - startX;
      var dy = e.clientY - startY;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.4) {
        go(gallery, dx < 0 ? 1 : -1);
        swiped = true;
        setTimeout(function () { swiped = false; }, 0);
      }
    });
    stage.addEventListener('pointercancel', function () { tracking = false; });
    // A swipe must not also count as a tap that opens the lightbox.
    stage.addEventListener('click', function (e) {
      if (swiped) { e.preventDefault(); e.stopPropagation(); }
    }, true);
  }

  function init() {
    var galleries = document.querySelectorAll('product-gallery');
    Array.prototype.forEach.call(galleries, bind);
  }

  if (document.readyState === 'complete') init();
  else window.addEventListener('load', init);
})();
